<div class="background-theme container-fluid custom-height" [ngClass]="stylingScheme">
  <div class="row">
    <div class="col-8 col-md-offset-2 mx-auto mb-5">

      <div class="pt-5">
        <h3>Sign In</h3>
        <p>Please enter your username and password to sign in to your account.</p>
      </div>

      <app-login-form></app-login-form>

    </div>
  </div>
</div>
